import $ from 'jquery'

const initializeBlock = function ($block) {
  const el = $block.find('.youtube-video-iframe')
  const overlayEl = $block.find('.video-image-button-block__video-overlay')
  const ytId = el.attr('data-id')

  el.append(`<img src="//i.ytimg.com/vi/${ytId}/maxres2.jpg" alt="YouTube Thumbnail">`)

  overlayEl.on('click', function () {
    overlayEl.remove()
    $block.find('.video-thumbnail').css('display', 'none')
    el.replaceWith(`<iframe src="https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1" allow="autoplay">`)
    var video = $block.find('video')
    video[0].play();
  })

}

$('.video-image-button-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=nrj-video-image-button', initializeBlock)
}
